import React, { useState } from "react";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import CommonBreadcrumb from "../../components/common/CommonBreadcrumb";
import { postMultiPartRequest } from "../../helper/AxiosHelper";

export default function Component() {
  const [file, setFile] = useState(null);
  const [result, setResult] = useState(null);
  const [isImporting, setIsImporting] = useState(false);

  const importCsv = () => {
    if (!file) {
      toast.error("請選擇 CSV 檔案");
      return;
    }
    setIsImporting(true);
    postMultiPartRequest("skillInfo/import", { file }, (isSuccess, message, body) => {
      setIsImporting(false);
      if (!isSuccess) {
        toast.error(typeof message === "string" && message ? message : "匯入失敗");
        return;
      }
      const importResult = body?.result || {};
      setResult(importResult);
      toast.success("匯入完成");
    });
  };

  return (
    <Container maxWidth={"lg"}>
      <CommonBreadcrumb />
      <Box sx={{ mt: 3 }}>
        <Paper sx={{ px: 3, py: 5 }} elevation={3}>
          <Stack spacing={2}>
            <Typography variant="h5">匯入技能 CSV</Typography>
            <Typography variant="body2" color="text.secondary">
              使用匯出的 CSV。系統以技能代碼更新現有技能，代碼不存在時會新增。JSON 欄位包括 projects、import_setting、skill_rank_male、skill_rank_female。
            </Typography>
            <Button variant="outlined" component="label">
              {file ? file.name : "選擇 CSV"}
              <input
                hidden
                type="file"
                accept=".csv,text/csv"
                onChange={(event) => {
                  setFile(event.target.files?.[0] || null);
                  setResult(null);
                }}
              />
            </Button>
            <Box>
              <Button variant="contained" onClick={importCsv} disabled={isImporting}>
                匯入
              </Button>
            </Box>
            {result ? (
              <Box>
                <Typography>新增 {result.created || 0} 筆</Typography>
                <Typography>更新 {result.updated || 0} 筆</Typography>
                <Typography>失敗 {result.failed || 0} 筆</Typography>
                {Array.isArray(result.errors) && result.errors.length > 0 ? (
                  <Box component="ul">
                    {result.errors.map((error, index) => (
                      <li key={`${index}-${error}`}>{error}</li>
                    ))}
                  </Box>
                ) : null}
              </Box>
            ) : null}
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
}
